module.exports = __webpack_public_path__ + "static/liva-pastacilik-case-study-c728dcf4b53dd8d0c7e34e280aa3a5a3.png";